import { OssMetricCards } from "../common/OssMetricCards";

export const OssOrderSummaryCards = ({ summary, filters, onFilterChange }) => {
  const activeKey = filters.riskLevel === "DELIVERY_RISK" ? "DELIVERY_RISK"
    : filters.status || (filters.riskLevel ? "CUSTOM" : "ALL");
  return <OssMetricCards activeKey={activeKey} items={[
    { label: "전체", value: summary.total, unit: "건", filterKey: "ALL", tone: "#3b82f6" },
    { label: "확인 필요", value: summary.checkRequired, unit: "건", filterKey: "CHECK_REQUIRED", tone: "#f59e0b" },
    { label: "변경 검토", value: summary.changeReview, unit: "건", filterKey: "CHANGE_REVIEW", tone: "#8b5cf6" },
    { label: "납기 위험", value: summary.deliveryRisk, unit: "건", filterKey: "DELIVERY_RISK", tone: "#ef4444" },
  ]} onItemClick={(key) => {
    const selected = key === activeKey || key === "ALL" ? "" : key;
    onFilterChange({ status: selected === "DELIVERY_RISK" ? "" : selected, riskLevel: selected === "DELIVERY_RISK" ? selected : "" });
  }} />;
};
